import React from "react";
import { Form } from "react-bootstrap";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./TransitionFormLabel.css";


type TransitionFormLabelProps = React.FC<{
  delay:number;  
}>

const TransitionFormLabel: TransitionFormLabelProps = ({
  delay = 1000,
  ...props
}) => {
  return (
    <>
      <TransitionGroup>
        <CSSTransition
          timeout={400}
          classNames="label-form-transition"
          style={{
            transition: `opacity ${delay}ms, transform ${delay}ms`,
          }}
          unmountOnExit
          appear
        >
          <Form.Label>{props.children}</Form.Label>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
};

export default TransitionFormLabel;